var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDraft)?[_c('el-tag',{staticClass:"font-medium mt-0.5",attrs:{"size":_vm.size,"type":"warning","effect":_vm.statusEffect}},[_vm._v("Draft")])]:[_c('el-tag',{staticClass:"font-medium mt-0.5",attrs:{"size":_vm.size,"type":_vm.statusType,"effect":_vm.statusEffect}},[_vm._v(_vm._s(_vm.statusText))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }